import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import axios from "axios";
import { API_BASE } from "../lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const sessionId = window.location.hash.split("session_id=")[1]?.split("&")[0];
    if (!sessionId) {
      navigate("/admin", { replace: true });
      return;
    }

    axios
      .post(
        `${API_BASE}/api/auth/session`,
        { session_id: sessionId },
        { withCredentials: true }
      )
      .then((res) => {
        navigate("/admin", { replace: true, state: { user: res.data.user } });
      })
      .catch(() => {
        navigate("/admin", { replace: true });
      });
  }, [navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-cream">
      <div className="flex items-center gap-3 text-navy" data-testid="auth-callback-loading">
        <Loader2 className="animate-spin text-gold-dark" size={22} />
        <span className="text-sm font-semibold">Connexion en cours…</span>
      </div>
    </div>
  );
}
